import { BLOCKS } from '@contentful/rich-text-types';

import { CHANNEL } from '@boss/constants/corporate-jobs';
import { RichText } from '@boss/rich-text';
import { HeroFields } from '@boss/types/corporate-jobs';

import { heroVariant } from '../../utils/options';
import ComponentMapper from '../ComponentMapper';

const getHeroProps = (entry: HeroFields, locale: string) => {
  const { text, backgroundImage, backgroundVideo, backgroundColor, autoplayVideo } = entry;

  return {
    autoplayVideo,
    backgroundColor: backgroundColor?.value,
    className: !!backgroundVideo?.file?.url && heroVariant === 'primary' ? 'rounded-brand' : '',
    image: backgroundImage?.image?.file?.url,
    imageAlt: backgroundImage?.image?.title,
    title: text ? (
      <RichText
        ComponentMapper={ComponentMapper}
        content={text}
        mapperOptions={{ locale }}
        renderNode={{
          [BLOCKS.PARAGRAPH]: (_, children) => <>{children}</>,
        }}
        renderOptions={{ noWrapper: true }}
      />
    ) : null,
    titleClassName: CHANNEL === 'jobs-b2c' ? 'font-gotham font-bold' : undefined,
    videoSrc: backgroundVideo?.file?.url,
    variant: heroVariant,
  };
};

export default getHeroProps;
